module.exports = __webpack_public_path__ + "img/a99ac82.jpg";